import * as Sentry from "@sentry/vue";
import { type Event } from "@sentry/vue";
import "virtual:vite-plugin-sentry/sentry-config";
import type { App } from "vue";
import type { Router } from "vue-router";

// now you can use this variable like so
const dist = import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist;
const release = import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release;
const environment = process.env.NODE_ENV;

// Check if we're running on localhost
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.includes(".local"));

// Disable Sentry in development or on localhost
const shouldEnableSentry = !isLocalhost;

export default {
  install(app: App<Element>, router: Router) {
    Sentry.init({
      dist,
      app,
      dsn: "https://a196814f20f947a0899bc0e786ac0ceb@sentry.ist.com/9",
      release: release,
      environment: environment,
      enabled: shouldEnableSentry,
      integrations: [
        Sentry.browserTracingIntegration({
          router
        })
      ],
      tracePropagationTargets: [/^https:\/\/ist\.dk\//, /^https:\/\/ist\.com\//, /^\//],
      beforeSend(event: Event): any {
        // Additional check to prevent localhost events from being sent
        if (!shouldEnableSentry) {
          return null;
        }

        if (event.extra && event.extra.propsData) {
          const s: string = JSON.stringify(event.extra.propsData);
          if (s.length > 10000) {
            event.extra.propsData = { jsonstring: s.substring(0, 10000) };
          }
        }

        return event;
      },
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: shouldEnableSentry ? 1.0 : 0
    });

    // Use modern scope API instead of deprecated configureScope
    if (shouldEnableSentry) {
      const scope = Sentry.getCurrentScope();
      scope.setTag("JENKINSID", import.meta.env.VITE_VUE_APP_VERSION || "");
    }

    app.config.errorHandler = (msg, vm, info) => {
      // eslint-disable-next-line
      console.error("errorHandler", msg, vm, info);
    };
  }
};
